import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "firebaseConfig";
import { BugReport } from "types/bugTypes";

const COLLECTION = "bugs";

export async function createBugReport(
  data: Omit<BugReport, "id" | "status" | "priority" | "adminNotes" | "createdAt" | "updatedAt">
): Promise<string> {
  const docRef = await addDoc(collection(db, COLLECTION), {
    ...data,
    status: "open",
    priority: "medium",
    adminNotes: "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
}

export async function fetchBugReports(): Promise<BugReport[]> {
  const q = query(
    collection(db, COLLECTION),
    orderBy("createdAt", "desc"),
    limit(200)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({
    ...(d.data() as Omit<BugReport, "id">),
    id: d.id,
  }));
}

export async function fetchBugReport(id: string): Promise<BugReport | null> {
  const docSnap = await getDoc(doc(db, COLLECTION, id));
  if (!docSnap.exists()) return null;
  return { ...(docSnap.data() as Omit<BugReport, "id">), id: docSnap.id };
}

export async function updateBugReport(
  id: string,
  updates: Partial<Pick<BugReport, "status" | "priority" | "adminNotes">>
): Promise<void> {
  await updateDoc(doc(db, COLLECTION, id), {
    ...updates,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteBugReport(bug: BugReport): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, bug.id));
}
